import { Axios, AxiosResponse } from "axios";
import { http, ServerType } from "../http";
import { IFavoriteModel, IFeatureCollectionModel, IGetCountriesTreeResModel,IGetLocationsResModel } from "./responseType";
import {IOperateFavoriteReqModel,IGetLightningTypeContoursReqModel,ISaveFeedbackReqModel} from "./requestType";

const getCountriesTree = async (countries?: string) => {
    const url = "/api/Lightning/GetCountriesTree";
    const res = await http.post<{countries?:string},AxiosResponse<IGetCountriesTreeResModel[]>>(url,
        {
            countries: countries
        },
        ServerType.ServerSimulation,
        false,
        null,
        false,
    );
    return res;
};

const getBoundaries = async (code?: string) => {
    const url = "/api/Lightning/GetBoundaries";
    const res = await http.post<{code?:string},AxiosResponse<IFeatureCollectionModel>>(url,
        {
            code: code
        },
        ServerType.ServerSimulation,
        false,
        null,
        false
    );
    return res;
};

const operateFavorite = async (data: IOperateFavoriteReqModel) => {
    const url = "/api/Lightning/OperateFavorite";
    const res = await http.post<IOperateFavoriteReqModel,AxiosResponse<IFavoriteModel[]>>(url,
        data,
        ServerType.ServerSimulation,
        true,
        null,
        false
    );
    return res;
};

const isExistsAuthorCode = async (authorCode?: string) => {
    const url = "/api/Lightning/IsExistsAuthorCode";
    const res = await http.post<{authorCode?: string},AxiosResponse<boolean>>(url,
        {
            authorCode: authorCode
        },
        ServerType.ServerSimulation,
        false,
        null,
        false
    );
    return res;
};

const getLocations = async (searchText:string) => {
    const url = "/api/Lightning/GetLocations?searchText="+searchText;
    const response = await http.get<null, AxiosResponse<IGetLocationsResModel[]>>(url,
        null,
        ServerType.ServerSimulation
    );
    return response;
};

const getLightningTypeContours = async (data: IGetLightningTypeContoursReqModel) => {
    const url = "/api/Lightning/GetLightningTypeContours";
    const res = await http.post<IGetLightningTypeContoursReqModel,AxiosResponse<IFeatureCollectionModel>>(url,
        data,
        ServerType.ServerPublicService,
        true,
        null,
        false
    );
    return res;
};

const saveFeedback = async (data: ISaveFeedbackReqModel) => {
    const url = "/api/Lightning/SaveFeedback";
    const res = await http.post<ISaveFeedbackReqModel,AxiosResponse<any>>(url,
        data,
        ServerType.ServerSimulation,
        true,
        null,
        false
    );
    return res;
};

export {
    getCountriesTree,
    getBoundaries,
    operateFavorite,
    isExistsAuthorCode,
    getLocations,
    getLightningTypeContours,
    saveFeedback
};

